import { Fragment, useState, useEffect } from "react";
import { TitleHeader, CardReport } from "../../components";
import { Select } from "antd";
import lista_usuario from "../../assets/lista_usuario.png";
import file_excel from "../../assets/excel.png";
import icon_absence from "../../assets/absence.png";
import icon_participante from "../../assets/participante-group.png";

import {
  downloadAsistencias,
  downloadConsolidado,
  downloadFaltaron,
  downloadParticipantes
} from "../../api/reporte";
import {
  isPorSedeEnabled,
  getAllSedes,
  isPorPeriodoEnabled,
  getAllPeriodos
} from "../../api/auxiliar";
import { DATE_LIKE_NAME } from "../../utils/functions";
import { TITLE_SISTEMA_SHORT } from "../../utils/shared";

function Reportes(props) {
  const [porSedeEnabled, setPorSedeEnabled] = useState(false);
  const [sedes, setSedes] = useState([]);
  const [selectedSede, setSelectedSede] = useState(null);

  const [porPeriodoEnabled, setPorPeriodoEnabled] = useState(false);
  const [periodos, setPeriodos] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);

  useEffect(() => {
    const fetchPorSedeConfig = async () => {
      try {
        const res = await isPorSedeEnabled();
        setPorSedeEnabled(res.payload.porSedeEnabled);
        
        if (res.payload.porSedeEnabled) {
          const sedesRes = await getAllSedes();
          setSedes(sedesRes.payload);
        }

        const periodoConfig = await isPorPeriodoEnabled();
        setPorPeriodoEnabled(periodoConfig.payload.porPeriodoEnabled);

        if (periodoConfig.payload.porPeriodoEnabled) {
          const periodosRes = await getAllPeriodos();
          setPeriodos(periodosRes.payload);
        }
      } catch (err) {
        console.error("Error al obtener configuración de sede:", err);
      }
    };
    fetchPorSedeConfig();
  }, []);
  const downloadAsistenciaConsolidado = async () => {
    const blob = await downloadConsolidado(selectedSede, selectedPeriodo);
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${TITLE_SISTEMA_SHORT}-consolidado-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const downloadAsistenciaFaltaron = async () => {
    const blob = await downloadFaltaron(selectedSede, selectedPeriodo);
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${TITLE_SISTEMA_SHORT}-faltaron-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const downloadAsistenciaParticipantes = async () => {
    const blob = await downloadParticipantes(selectedSede);
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${TITLE_SISTEMA_SHORT}-participante-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const downloadExcelAsistencia = async () => {
    const blob = await downloadAsistencias(selectedSede, selectedPeriodo);
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${TITLE_SISTEMA_SHORT}-${DATE_LIKE_NAME}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  return (
    <Fragment>
      <TitleHeader title="Reportes" />
      
      {(porSedeEnabled || porPeriodoEnabled) && (
        <div className="mb-4">
          <div className="flex gap-2 flex-col md:flex-row">
            {porSedeEnabled && (
              <Select
                placeholder="Filtrar por sede"
                allowClear
                style={{ width: 300 }}
                onChange={(value) => setSelectedSede(value)}
                options={[
                  { value: null, label: "Todas las sedes" },
                  ...sedes.map((sede) => ({
                    value: sede.idsede,
                    label: sede.nombre
                  }))
                ]}
              />
            )}

            {porPeriodoEnabled && (
              <Select
                placeholder="Filtrar por periodo"
                allowClear
                style={{ width: 300 }}
                onChange={(value) => setSelectedPeriodo(value)}
                options={[
                  { value: null, label: "Todos los periodos" },
                  ...periodos.map((periodo) => ({
                    value: periodo.idperiodo,
                    label: `${periodo.nombre}${periodo.siglas ? ` (${periodo.siglas})` : ""}`
                  }))
                ]}
              />
            )}
          </div>
        </div>
      )}
      
      <div className="flex gap-2">
        <CardReport
          onClick={downloadExcelAsistencia}
          desc="Descargar asistencias"
          imgSrc={lista_usuario}
          imgAlt="imagen lista asistencias"
        />
        <CardReport
          onClick={downloadAsistenciaConsolidado}
          desc="Descargar asistencias consolidado"
          imgSrc={file_excel}
          imgAlt="imagen lista asistencia consolidado"
        />
        <CardReport
          onClick={downloadAsistenciaFaltaron}
          desc="Descargar asistencias Faltaron"
          imgSrc={icon_absence}
          imgAlt="imagen lista asistencia faltaron"
        />
        <CardReport
          onClick={downloadAsistenciaParticipantes}
          desc="Descargar asistencia participantes"
          imgSrc={icon_participante}
          imgAlt="imagen lista asistencia faltaron"
        />
      </div>
    </Fragment>
  );
}

export default Reportes;
